import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { RenderSharedModule } from 'render/render-shared/render-shared.module';

import { RenderProductPricesComponent } from './render-product-prices.component';


@NgModule({
  declarations: [
    RenderProductPricesComponent,
  ],
  imports: [
    CommonModule,
    RenderSharedModule
  ],
  exports: [
    RenderProductPricesComponent,
  ]
})
export class RenderProductPricesModule { }
